import { get,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";




  export const getPageDetailsByPageTypeId = async (pageTypeId:number): Promise<DataResponse<any>> => {
   
      const url = `${endpoints.getPageByPageTypeId}/${pageTypeId}`;
      const config = headers.content_type.application_json;
      return get<DataResponse<any>>(url, config);
    };
  